/**
 * Calcula a média das curvas de ECG para visualização
 * Agrupa os dados por ciclos cardíacos e calcula a média
 *
 * @param data - Array de dados ECG { time, voltage }
 * @param durationSeconds - Duração em segundos para usar no cálculo (padrão: 1s)
 * @returns Array com a curva média
 */
export const calculateAverageWaveform = (
  data: Array<{ time: number; voltage: number }>,
  durationSeconds: number = 1
): Array<{ time: number; voltage: number }> => {
  // Para 1 segundo a 25mm/s = 25mm
  const maxTimeInMm = durationSeconds * 25

  // Filtrar apenas os primeiros 1s de dados
  const filteredData = data.filter(point => point.time <= maxTimeInMm)

  // Por enquanto, retorna os dados filtrados
  // TODO: Implementar algoritmo de média de ciclos cardíacos
  return filteredData
}
